export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  pending_approval: "bg-amber-50 text-amber-800 border-amber-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  processed: "bg-sky-50 text-sky-800 border-sky-200",
  rejected: "bg-rose-50 text-rose-800 border-rose-200",
};

export const STATUS_LABELS = {
  draft: "Draft",
  pending_approval: "Pending Approval",
  approved: "Approved",
  processed: "Processed",
  rejected: "Rejected",
};

export function StatusBadge({ status }) {
  return (
    <span
      data-testid="payroll-status-badge"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${STATUS_STYLES[status] || STATUS_STYLES.draft}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {STATUS_LABELS[status] || status}
    </span>
  );
}
